
export const rostersHasUserIdModifications = rosterPositions => {
  // Make sure we don't save if there are modifications in the user ID 

  let hasRosterPositionChanged = false;

  rosterPositions.map(roster => {
    let modifiedWithValue = roster._searchChanged &&
      (roster._searchValue !== roster.bowler.usbcId);

    if (roster._searchValue === "" && !roster.bowler.usbcId) modifiedWithValue = false;
    if (modifiedWithValue)
    {
      hasRosterPositionChanged = true;
      roster.usbcIdError = true;
    }
  });

  return hasRosterPositionChanged;
};



// WEBPACK FOOTER //
// ./src/features/shared/actionRosterPosition.js